import { Link, useLocation } from "react-router-dom";

import "../xo_hub/xo_hub.css";

import {
  activeCenterNavId,
  isXOCenterSurface,
  XO_CENTER_FIRST_VISIT_NAV,
} from "../../lib/xo_center_visibility";

/**
 * xo.center first-visit navigation — five buckets only (Horizon excluded).
 */
export function XOCenterNav({ className }: { className?: string }) {
  const { pathname, hash } = useLocation();
  const hostname =
    typeof globalThis !== "undefined" && "location" in globalThis
      ? (globalThis as unknown as { location: { hostname: string } }).location.hostname
      : "";

  if (!isXOCenterSurface(hostname, pathname)) return null;

  const active = activeCenterNavId(pathname, hash);

  return (
    <nav className={className ? `xo-center-nav ${className}` : "xo-center-nav"} aria-label="XO Center" data-testid="xo-center-nav">
      <ol className="xo-center-nav__list">
        {XO_CENTER_FIRST_VISIT_NAV.map((item) => {
          const isActive = active === item.id;
          const className = isActive
            ? "xo-center-nav__link xo-center-nav__link--active"
            : "xo-center-nav__link";
          return (
            <li key={item.id}>
              <Link to={item.href} className={className} data-testid={`xo-center-nav-${item.id}`}>
                {item.label}
              </Link>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
